export class CurrencyConverter {
    private readonly eurChanges: Record<string, number | undefined>;

    constructor() {
        this.eurChanges = {
            XOF: 655.957,
            GNF: 9274.52,
            EUR: 1.0,
        };
    }

    toEUR(amount: number, currency: string): number {
        currency = currency.toUpperCase();

        if ('EUR' === currency) {
            return amount;
        }

        const change = this.getEurChangeOrThrow(currency);

        return amount / change;
    }

    change(amount: number, currency: string, newCurrency: string): number {
        currency = currency.toUpperCase();
        newCurrency = newCurrency.toUpperCase();

        if (currency === newCurrency) {
            return amount;
        }

        const eur = this.toEUR(amount, currency);
        const change = this.getEurChangeOrThrow(newCurrency);

        return eur * change;
    }

    private getEurChangeOrThrow(currency: string): number {
        const rate = this.eurChanges[currency] ?? undefined;
        if (rate !== undefined) {
            return rate;
        } else {
            throw new Error(
                `Le taux de conversion pour cette monnaie ${currency} est inconnue`,
            );
        }
    }
}
